import { Country } from "$src/domain/map/Country";
import type { ILocalityRepository } from "$src/domain/map/ILocalityRepository";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetCountries {
    
    constructor(@inject(ServiceTokens.LocalityRepository) private localityRepository: ILocalityRepository) {}

    async execute(languageCode: string): Promise<Country[]> {
        var countries = await this.localityRepository.getCountries(languageCode);
        return countries;
    }
}

export const GetCountriesToken = Symbol('GetCountriesToken');    
